/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { globalBreak } from '@/styles/break';
import { SxProps } from '@mui/material';

export const productCardSX = ({helloRetailCard}:{helloRetailCard:number}): SxProps => ({
	position:'relative',
	p: globalBreak({mobile:1.5, desktop:'15px'}),
	width: helloRetailCard === 1 ? '98%':'100%',
	display: 'flex',
	border:'1px solid #c4c4c3',
	boxShadow:0,
	flexDirection: 'column',
	'&:hover': {
		boxShadow: 0,
		textDecoration: 'none'
	},
	textDecoration:'none',
	'&:focus-visible':{
		outlineOffset:0,
		outline:'1px solid',
		borderRadius:1
	}
});
